// components/ui/Textarea.jsx
import React from 'react';

export const Textarea = ({
  className = '',
  label = '',
  error,
  required,
  name,
  id,
  ...props
}) => {
  const textareaId = id || name;
  const hasError = error && error.length > 0;

  return (
    <div>
      {label && (
        <label
          htmlFor={textareaId}
          className={`mb-1 block font-medium ${hasError ? 'text-red-700' : 'text-gray-700'}`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        name={name}
        className={`
          w-full px-3 py-2 rounded-lg focus:outline-none focus:ring-1 transition-colors
          ${hasError
            ? 'border-red-300 bg-red-50 text-red-900 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 bg-white text-gray-900 focus:border-blue-500 focus:ring-blue-500'
          }
          ${className}
        `}
        {...props}
      />
      {hasError && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
